import {
	Entities,
	EntityStatus,
	FeedTank,
	Product,
	ProductType,
	Tank,
	Vat,
	WaterMeter,
	WaterMonitor,
	WaterTank,
} from '@/api';

export function isLastEntityOnProduct(product: Product): boolean {
	let entities: any[] = [];
	switch (product.type) {
		case ProductType.Milk:
			entities = product.vats ?? [];
			break;
		case ProductType.Fuel:
			entities = product.tanks ?? [];
			break;
		case ProductType.Water:
			entities = [
				...(product.watermeters ?? []),
				...(product.watertanks ?? []),
				...(product.watermonitors ?? []),
			];
			break;
		case ProductType.Feed:
			entities = product.feedtanks ?? [];
			break;
	}
	return (
		entities.filter(
			entity =>
				entity.status != null &&
				![EntityStatus.Removed, EntityStatus.Cancelled].includes(entity.status),
		).length === 1
	);
}

export function isRemovingLastEntitiesOnProduct(
	product: Product,
	entitiesRemoved: {
		vats?: any[];
		tanks?: any[];
		waterMeters?: any[];
		waterTanks?: any[];
		waterMonitors?: any[];
		feedTanks?: any[];
	},
): boolean {
	let entities: any[] = [];
	switch (product.type) {
		case ProductType.Milk:
			entities = (product.vats ?? []).filter(
				e => entitiesRemoved.vats?.findIndex(f => e.id === f.id) === -1,
			);
			break;
		case ProductType.Fuel:
			entities = (product.tanks ?? []).filter(
				e => entitiesRemoved.tanks?.findIndex(f => e.id === f.id) === -1,
			);
			break;
		case ProductType.Water:
			entities = [
				...(product.watermeters ?? []).filter(
					e => entitiesRemoved.waterMeters?.findIndex(f => e.id === f.id) === -1,
				),
				...(product.watertanks ?? []).filter(
					e => entitiesRemoved.waterTanks?.findIndex(f => e.id === f.id) === -1,
				),
				...(product.watermonitors ?? []).filter(
					e => entitiesRemoved.waterMonitors?.findIndex(f => e.id === f.id) === -1,
				),
			];
			break;
		case ProductType.Feed:
			entities = (product.feedtanks ?? []).filter(
				e => entitiesRemoved.feedTanks?.findIndex(f => e.id === f.id) === -1,
			);
			break;
	}
	return (
		entities.filter(
			entity =>
				entity.status != null &&
				![EntityStatus.Removed, EntityStatus.Cancelled].includes(entity.status),
		).length === 0
	);
}
